import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ContractSelector from '@cimpress-technology/ff-react-components/lib/ContractSelector';
import ErrorText from '../Shared/ErrorText';

class ContractSelectorField extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    input: PropTypes.object.isRequired,
    contracts: PropTypes.arrayOf(PropTypes.object).isRequired
  };

  render() {
    const { className, input, contracts, meta } = this.props;
    const { value, onChange } = input;

    return (
      <>
        <div className={className}>
          <ContractSelector onSelect={onChange} contracts={contracts} selectedContract={value} />
        </div>
        {meta.touched && meta.error && <ErrorText text={meta.error} />}
      </>
    );
  }
}

export default ContractSelectorField;
